module.exports = __webpack_public_path__ + "img/Home.809f89af.gif";